// src/components/UploadSuccessCard.tsx

import { IconWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const styles: IStyles = {
  root: {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#E9FFF2',
    border: '1px dashed #3CCF91',
    borderRadius: pxToRem(8),
    padding: { xs: pxToRem(10), md: pxTovW(20) },

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: pxToRem(10),
    textAlign: 'center',
  },

  title: {
    color: '#1DB954',
    fontWeight: 600,
  },

  subtitle: {
    fontSize: pxToRem(14),
    color: '#1F1F1F',
  },
};

interface UploadSuccessCardProps {
  title?: string;
  subtitle?: string;
}

export const UploadSuccessCard = ({
  title = 'Success!',
  subtitle = 'File Uploaded Successfully.',
}: UploadSuccessCardProps) => {
  return (
    <Box sx={styles.root}>
      <CheckCircleIcon fontSize="large" sx={{ color: '#0F8F10' }} />

      <Typography variant="h4" sx={styles.title}>
        {title}
      </Typography>

      <Typography sx={styles.subtitle}>{subtitle}</Typography>
    </Box>
  );
};
